<template>
  <div class="main-wrap">
    <!-- 头部信息区域 start -->
    <div class="header-info">
      <div class="header-bg"></div>
      <div class="container">
        <div class="top">
          <div class="supplier-wrap">
            <div class="abbreviation">{{ title.abbreviation }}</div>
            <div class="fullName">{{ title.name }}</div>
          </div>
          <van-button class="bt-info" round color="#51596e" size="small" @click="showSupplierInofHandle">
            供应商详情</van-button
          >
        </div>
        <div class="bottom">
          <van-row class="card-wrap">
            <van-col :span="8" @click="showPopupHandle">
              <div class="yellow">￥{{ title.thismounthsubsist }}</div>
              <div class="label">{{ "本月应付账款" }}</div>
            </van-col>
            <van-col :span="8">
              <div class="yellow">￥{{ title.totalsubsist }}</div>
              <div class="label">{{ "总应付账款" }}</div>
            </van-col>
            <van-col :span="8">
              <div class="yellow">￥{{ title.currency_amount }}</div>
              <div class="label">{{ "总采购金额" }}</div>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
    <!-- 头部信息区域 end -->

    <!-- 供应商统计图 start -->
    <van-row class="middle">
      <van-row class="label">供应商采购金额统计图</van-row>
      <van-row class="charts-wrap">
        <div id="myChart" ref="myChart"></div>
      </van-row>
    </van-row>
    <!-- 供应商统计图 end -->

    <!-- 采购分析 start  -->
    <div class="footer analyse">
      <div class="label">采购分析</div>
      <van-row class="analyse-list" gutter="20" type="flex" justify="center">
        <van-col class="item" :span="12" v-for="(item, index) in analyseList" :key="index">
          <van-row gutter="0" type="flex" align="center">
            <van-col :span="4">
              <van-row class="label">
                <van-col>{{ item.label }}</van-col>
              </van-row>
            </van-col>
            <van-col :span="20">
              <van-row class="item-text">
                <van-col :span="24" v-for="(item1, index1) in item.list" :key="index1"
                  >{{ item1.text }}: <span class="golden">{{ item1.value }}</span></van-col
                >
              </van-row>
            </van-col>
          </van-row>
        </van-col>
      </van-row>
    </div>
    <!-- 采购分析 end  -->

    <!-- 供应商详情对话框 start -->
    <van-dialog
      className="supplierDialog"
      v-model="supplierDialogShow"
      lockScroll
      theme="round-button"
      confirmButtonText="关 闭"
      confirmButtonColor="#51596e"
    >
      <van-row>
        <van-col :span="16"
          ><span class="name">{{ title.name }}</span></van-col
        >
        <van-col :span="8"
          ><span class="right bg-green">等级: {{ title.grade }}</span></van-col
        >
      </van-row>
      <van-row class="info-table">
        <van-row>
          <van-col :span="17"><span class="title">联系信息 </span></van-col>
          <van-col :span="7">
            <span class="right bg-blue">{{ title.type }}</span>
          </van-col>
        </van-row>
        <van-divider :style="{ borderColor: '#999', margin: '12px 0' }" />
        <van-row>
          <van-col class="tr" :span="24" v-for="(item, index) in list1" :key="index">
            <span class="text">{{ item.text }}:&nbsp;&nbsp;&nbsp;</span>
            <span class="value">{{ item.value }}</span>
          </van-col>
        </van-row>
      </van-row>
      <van-row class="info-table">
        <van-row>
          <van-col :span="16"><span class="title">付款信息 </span></van-col>
        </van-row>
        <van-divider :style="{ borderColor: '#999', margin: '12px 0' }" />
        <van-row>
          <van-col class="tr" :span="24" v-for="(item, index) in list2" :key="index">
            <span class="text">{{ item.text }}:&nbsp;&nbsp;&nbsp;</span>
            <span class="value">{{ item.value }}</span>
          </van-col>
        </van-row>
      </van-row>
    </van-dialog>
    <!-- 供应商详情对话框 end -->

    <!-- 本月应付账款  popup start -->
    <van-popup
      v-model="popupShow"
      :overlay="false"
      position="right"
      :style="{ width: '100%', height: '101%', background: '#f8f8f8' }"
    >
      <van-row class="popup-container">
        <van-row class="info">
          <van-row class="title">{{ title.name }}</van-row>
          <van-row>
            <van-col>本月应付账款</van-col>
            <van-col class="right "
              ><span class="green"> ￥{{ title.thismounthsubsist }}</span></van-col
            >
          </van-row>
          <van-divider :style="{ borderColor: '#999', margin: '12px 0' }" />
          <van-row class="card-wrap" gutter="20">
            <van-col :span="12">
              <van-row>
                <div>￥{{ listTitle.thismouthhavein }}</div>
                <div>本月已收开票金额</div>
              </van-row>
            </van-col>
            <van-col :span="12">
              <van-row>
                <div>{{ listTitle.thismouthhaveinorder }}</div>
                <div>本月待付款订单量</div>
              </van-row>
            </van-col>
          </van-row>
        </van-row>
        <!-- 折叠列表区域 start -->
        <van-list
          v-model="loadingList"
          :finished="finished"
          :error.sync="error"
          error-text="点击重新加载"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-collapse class="collapseWrap" title-class="title-order" v-model="activeNames">
            <van-collapse-item
              class="item-wrap"
              :title="'订单号:' + item.orderid"
              :name="item.orderid"
              v-for="item in orderList"
              :key="item.orderId"
            >
              <van-row class="text">订单状态: {{ item.status }}</van-row>
              <van-row class="text">订单金额: {{ item.amount }}</van-row>
              <van-row class="text">本月待付款金额: {{ item.mouthpay }}</van-row>
              <van-row class="text">
                <van-row>附件:</van-row>
                <van-row type="flex" gutter="20">
                  <van-col span="8" v-for="(item, index) in item.file" :key="index">
                    <a :href="item">
                      <van-image
                        width="100"
                        height="100"
                        fit="contain"
                        :src="imgUrl + '/admin/ajax/icon?suffix=' + formatSuffix(item)"
                      />
                    </a>
                  </van-col>
                </van-row>
              </van-row>
            </van-collapse-item>
          </van-collapse>
        </van-list>
        <!-- 折叠列表区域 end -->

        <div class="fixed-bottom">
          <van-button class="closeBtn" round block @click="popupShow = false">关闭</van-button>
        </div>
      </van-row>
    </van-popup>
    <!-- 本月应付账款  popup end -->
  </div>
</template>

<script>
import { BASE_URL } from "../../../../config/global.js";
import echarts from "echarts";
export default {
  data() {
    return {
      loading: false,
      supplierDialogShow: false,
      popupShow: false,
      activeNames: ["1", "2", "3"],
      analyseList: [],
      title: {
        id: 0,
        name: "供应商全称",
        abbreviation: "供应商简称",
        grade: "未知",
        thismounthsubsist: 0,
        totalsubsist: 0,
        currency_amount: "0.00",
        type: "行业供应商",
        list1: [],
        list2: [],
      },
      listTitle: [],
      list1: [],
      list2: [],
      orderList: [
        // {
        //   orderId: "320101200301027913",
        //   orderState: "已发货",
        //   moneyStr: "[CNY] 32111313.00",
        //   unpaidStr: "[CNY] 12111313.00",
        // },
        // {
        //   orderId: "140101197702082886",
        //   orderState: "未发货",
        //   moneyStr: "[CNY] 0.00",
        //   unpaidStr: "[CNY] 32231313.00",
        // },
        // {
        //   orderId: "610101197210247130",
        //   orderState: "未发货",
        //   moneyStr: "[CNY] 0.00",
        //   unpaidStr: "[CNY] 13223313.00",
        // },
      ],
      chartData: {},
      page: 1,
      loadingList: false,
      finished: false,
      error: false,
      imgUrl: BASE_URL,
    };
  },
  methods: {
    /**
     * 获取供应商信息
     */
    async getSupplierInfo() {
      let params = {
        id: this.$route.params.id,
      };
      let toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      let { data } = await this.$post(this.$api.stGetSupplierInfo, params);
      this.title = data.title;
      this.analyseList = data.box;
      this.listTitle = data.list_title;
      this.chartData = data.year.lists;
      this.list1 = data.title.list1;
      this.list2 = data.title.list2;
      this.echartInit();
      toast.clear();
    },
    /**
     * 初始化echarts
     */
    echartInit() {
      this.$nextTick(() => {
        var myChart = echarts.init(this.$refs.myChart);
        myChart.setOption({
          // title: { text: "会员趋势" },
          tooltip: { trigger: "axis" },
          color: ["#2a82e4"],
          grid: {
            left: "20px",
            right: "20px",
            top: "10px",
            bottom: "30px",
            containcolor_3: true,
          },
          // toolbox: { feature: { saveAsImage: {} } },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: this.chartData.dates,
          },
          yAxis: [
            {
              name: "销售额",
              type: "value",
              axisLabel: {
                formatter: function() {
                  return "";
                },
              },
            },
          ],
          series: [
            {
              name: "金额(CNY)",
              type: "line",
              data: this.chartData.price,
              yAxisIndex: 0,
              smooth: true,
            },
          ],
        });
      });
    },
    /**
     * 获取供应商详细信息
     */
    showSupplierInofHandle() {
      this.supplierDialogShow = true;
    },
    /**
     *
     */
    showPopupHandle() {
      this.popupShow = true;
    },

    async onLoad() {
      let params = {
        id: this.$route.params.id,
        page: this.page,
      };

      try {
        let { data } = await this.$post(this.$api.stGetSupplierOrderList, params);
        // 若数据已全部加载完毕
        if (data.length == 0) {
          this.finished = true;
        }
        if (this.page == 1) {
          this.orderList = [];
        }
        this.orderList.push(...data);
        this.page++;
      } catch (error) {
        console.log(error);
        this.error = true;
      } finally {
        this.loadingList = false;
      }
    },
    formatSuffix(url) {
      let arr = url.split("/");
      let filename = arr[arr.length - 1];
      arr = filename.split(".");
      let suffix = arr[arr.length - 1];
      return suffix;
    },
  },
  mounted() {
    this.getSupplierInfo();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "供应商统计" });
    });
  },
};
</script>

<style lang="scss" scoped>
$yellow: #ff8d1a;
$gary: #a6a6a6;
$golden: #a96929;
$green: #00baad;
$blue: #2a82e4;
.yellow {
  color: $yellow;
}
.gary {
  color: $gary;
}
.golden {
  color: $golden;
}
.green {
  color: $green;
}
.bg-green {
  background-color: $green;
}
.bg-blue {
  background-color: $blue;
}
.main-wrap {
  background-color: #f6f4f2;

  .header-info {
    box-sizing: border-box;
    padding: 15px 15px 0;
    background: linear-gradient(180deg, #fff 170px, #fff 170px, transparent);

    .header-bg {
      position: absolute;
      top: 0;
      right: 0;
      width: 302px;
      height: 170px;
      background: url("../../../../assets/images/bg_header.png") no-repeat top right/302px 170px;
      z-index: 0;
    }

    .container {
      position: relative;
      z-index: 1;

      .top {
        padding-top: 16px;
        color: #505050;
        .abbreviation {
          font-size: 18px;
        }
        .fullName {
          font-size: 12px;
        }
        .bt-info {
          margin-top: 20px;
        }
      }

      .bottom {
        margin-top: 16px;
        padding: 6px;
        background-color: rgba(255, 255, 255, 0.9);
        border-radius: 5px;
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.03), 1px -1px 4px rgba(0, 0, 0, 0.03), -1px -1px 4px rgba(0, 0, 0, 0.03),
          -1px 1px 4px rgba(0, 0, 0, 0.03);

        .card-wrap {
          padding: 8px;
          text-align: center;

          .label {
            margin-top: 8px;
            font-size: 12px;
          }
        }
      }
    }
  }

  .middle {
    padding: 15px;
    .label {
      font-size: 12px;
      color: $gary;
    }

    .charts-wrap {
      margin-top: 8px;
      border-radius: 8px;
      background-color: #fff;

      #myChart {
        width: 100%;
        height: 40vw;
      }
    }
  }

  .footer {
    padding: 15px;
    .label {
      font-size: 12px;
      color: $gary;
    }

    .analyse-list {
      margin-top: 8px;

      .item > .van-row {
        flex-direction: row;
        margin-bottom: 8px;
        padding: 8px;
        font-size: 12px;
        background-color: #fff;
        border-radius: 5px;
        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.185);

        .label {
          color: $golden;
          width: 24px;
          font-size: 12px;
        }
        .item-text {
          margin-left: 8px;
          .van-col {
            margin: 2px 0;
          }
        }
      }
    }
  }

  .supplierDialog {
    box-sizing: border-box;
    padding: 12px 20px 0;
    max-width: 90%;
    max-height: 80%;
    overflow-y: scroll;

    .van-row {
      margin: 4px 0;
      .name {
        position: relative;
      }
      .name::before {
        content: "";
        position: absolute;
        left: -6px;
        width: 0;
        height: 100%;
        border: 1px solid #00baad;
      }

      .right {
        float: right;
        padding: 4px 12px;
        font-size: 12px;
        color: #fff;
        border-radius: 16px;
      }
    }

    .info-table {
      margin-top: 18px;
      font-size: 12px;

      .title {
        color: #505050;
        font-weight: 500;
        font-size: 13px;
      }

      .tr {
        line-height: 2;
      }
    }
  }

  .popup-container {
    box-sizing: border-box;
    position: relative;
    padding: 16px 16px 80px;
    height: 100%;
    font-size: 12px;
    color: #505050;
    overflow: scroll;

    .right {
      float: right;
    }
    .fixed-bottom {
      box-sizing: border-box;
      position: fixed;
      padding: 0 20px;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 60px;
      background-color: #f8f8f8;

      .closeBtn {
        margin-top: 6px;
        text-align: center;
        letter-spacing: 8px;
        color: #fff;
        background-color: #51596e;
      }
    }

    .info {
      padding: 10px;
      .title {
        position: relative;
        font-size: 14px;
        margin-bottom: 10px;

        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: -4px;
          width: 0;
          height: 100%;
          border: 1px solid $green;
        }
      }

      .card-wrap {
        text-align: center;
        .van-col:nth-child(1) .van-row {
          padding: 6px;
          border-radius: 5px;
          background-color: $green;
        }
        .van-col:nth-child(2) .van-row {
          padding: 6px;
          border-radius: 5px;
          background-color: $blue;
        }
        .van-col div {
          padding: 4px 0 4px;
          color: #fff;
        }
      }
    }

    .collapseWrap {
      .item-wrap {
        margin: 16px 0;

        .text {
          line-height: 2;
          font-size: 12px;
          color: #505050;
        }
      }
      ::v-deep.van-cell__title {
        font-size: 12px;
        color: #505050;
      }
    }
  }
}
</style>
